import React from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import DateRangeIcon from '@material-ui/icons/DateRange';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from 'assets/jss/material-dashboard-pro-react/components/dateRangeFilterStyle.js';
import { shortDateFormat } from 'resolvers/date-format.resolver';
import Tooltip from '@material-ui/core/Tooltip';

class DateRangeFilter extends React.Component {
	onClear() {
		const  { onChange } = this.props;
		onChange('from', null);
		onChange('to', null);
	}
	render() {
		const {
			classes,
			displayName,
			dateFrom,
			dateTo,
			onChange,
		} = this.props;

		return (
			<div className={classes.dateRangeFilterWrapper}>
				<Tooltip title={`${displayName} from`}>
					<div className={classes.datetimeWrapper}>
						<DateRangeIcon className={classes.datetimeIcon} />
						<Datetime
							isValidDate={({ _d }) => {
								if ((new Date() < _d || ( dateTo && dateTo < _d))) {
									return false;
								}
								return true;
							}}
							inputProps={{ readOnly: true, placeholder: `${displayName} from` }}
							timeFormat={false}
							dateFormat={shortDateFormat}
							onChange={({ _d }) => onChange('from', _d)}
							value={dateFrom}
							closeOnSelect={true}
						/>
					</div>
				</Tooltip>
				<Tooltip title={`${displayName} to`}>
					<div className={classes.datetimeWrapper}>
						<DateRangeIcon className={classes.datetimeIcon} />
						<Datetime
							isValidDate={({ _d }) => {
								if (new Date() < _d || (dateFrom && moment(dateFrom).startOf('day') > _d)) {
									return false;
								}
								return true;
							}}
							inputProps={{ readOnly: true, placeholder: `${displayName} to` }}
							dateFormat={shortDateFormat}
							timeFormat={false}
							onChange={({ _d }) => onChange('to', moment(_d).endOf('day'))}
							value={dateTo}
							closeOnSelect={true}
						/>
					</div>
				</Tooltip>
				<Tooltip title='Clear date range filter'>
					<EventBusyIcon
						className={classes.clearIcon}
						onClick={() => { (dateFrom || dateTo) && this.onClear()}}
					/>
				</Tooltip>
			</div>
		)
	}
}

export default withStyles(styles)(DateRangeFilter);
